<template>
  <v-dialog
    v-model="show"
    max-width="800"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Проход {{ item ? item.public_id : '' }}</span>
      </v-card-title>
      <v-card-text v-if="item">
        <div
          v-for="block in blocks"
          :key="block.title"
          class="mb-4"
        >
          <div class="text-subtitle-1 font-weight-bold mb-1">
            {{ block.title }}
          </div>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr
                  v-for="row in block.rows"
                  :key="row[0]"
                >
                  <td style="width: 40%">
                    {{ row[0] }}
                  </td>
                  <td>{{ row[1] }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary darken-1"
          outlined
          rounded
          small
          class="ml-2 mb-2"
          @click="show = false"
        >
          <span class="mx-4">Закрыть</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { SkudPassageService } from '@/views/skud/shared/services/skud-passage-service'

function boolText (v) {
  return v ? 'Да' : 'Нет'
}

export default {
  name: 'SkudPassageViewDialog',
  data () {
    return {
      svc: null,
      show: false,
      item: null
    }
  },
  computed: {
    // Блоки с пропуском пустых значений (null/undefined/'' не рисуем).
    blocks () {
      const x = this.item
      if (!x) return []
      const row = (name, v) => (v === null || v === undefined || v === '') ? null : [name, v]
      const pack = (title, rows) => {
        const r = rows.filter(a => a !== null)
        return r.length ? { title: title, rows: r } : null
      }
      return [
        pack('Основное', [
          row('ID прохода', x.public_id),
          row('Место', x.place_name),
          row('Дата/время события', x.occurred_at),
          row('Записано на сервере', x.registered_at),
          row('Метод', x.method_text),
          row('Субъект', x.subject_ref),
          row('Гостевой пропуск', x.guest_pass_public_id)
        ]),
        pack('Терминал', [
          row('Точка', x.point_name),
          row('Экран', x.terminal_decision.screen),
          row('Причина', x.terminal_decision.reason),
          row('Направление', x.terminal_decision.direction_text),
          row('Индекс правила', x.terminal_decision.rule_index)
        ]),
        pack('Сервер', [
          row('Экран (пересмотр)', x.server_decision.revised_screen),
          row('Направление', x.server_decision.direction_text),
          row('Источник направления', x.server_decision.direction_source_text),
          row('Направление терминала', x.server_decision.terminal_direction_text),
          row('Расхождение направления', boolText(x.server_decision.direction_mismatch)),
          row('Подозрительный', boolText(x.server_decision.suspicious))
        ]),
        pack('Служебное', [
          row('UID события', x.event_uid),
          row('UID карты', x.credential_uid),
          row('Офлайн', boolText(x.offline)),
          row('Расхождение часов, сек', x.clock_skew_sec),
          row('Версия записи', x.record_version)
        ])
      ].filter(a => a !== null)
    }
  },
  mounted () {
    this.svc = new SkudPassageService()
  },
  methods: {
    async open (publicId, placeId) {
      if (!placeId) {
        this.$store.commit('snackbar', 'Неизвестное место прохода')
        return
      }
      const res = await this.svc.getPassage(placeId, publicId)
      if (!res) {
        this.$store.commit('snackbar', this.svc.error || 'Ошибка при получении данных')
        return
      }
      this.item = res
      this.show = true
    }
  }
}
</script>
